import React from "react";

interface CollapsiblePanelProps {
  title: string;
  isCollapsed: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  title,
  isCollapsed,
  onToggle,
  children,
}) => {
  return (
    <div className="relative">
      <div className="rounded-xl border border-gray-200 bg-white/90 shadow-md hover:shadow-lg transition-shadow">
        <button
          onClick={onToggle}
          aria-expanded={!isCollapsed}
          className="w-full flex items-center justify-between px-5 py-4 rounded-xl
                     transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        >
          <h3 className="text-base font-semibold text-gray-800">{title}</h3>

          <svg
            viewBox="0 0 24 24"
            className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
              isCollapsed ? "" : "rotate-180"
            }`}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div
          className={`grid transition-[grid-template-rows] duration-300 ease-out px-5 ${
            isCollapsed ? "grid-rows-[0fr]" : "grid-rows-[1fr]"
          }`}
        >
          <div className="overflow-hidden">
            <div className="pb-5 pt-1 text-gray-700">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollapsiblePanel;
